<!-- @component Display the contents only if the user is an admin. -->

<script lang="ts">
  import type { Snippet } from "svelte";

  import { user } from "$lib/user";

  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();
</script>

{#if $user?.logged_in && $user.is_admin}
  {@render children?.()}
{/if}
